var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49701 6.00331C7.49701 5.19133 6.83875 4.53308 6.02675 4.53308C5.21478 4.53308 4.55652 5.19133 4.55652 6.00331C4.55652 6.81531 5.21478 7.47357 6.02675 7.47357C6.83875 7.47357 7.49701 6.81531 7.49701 6.00331ZM7.98709 6.00331C7.98709 7.08594 7.10938 7.96365 6.02675 7.96365C4.94414 7.96365 4.06641 7.08594 4.06641 6.00331C4.06641 4.9207 4.94414 4.04297 6.02675 4.04297C7.10938 4.04297 7.98709 4.9207 7.98709 6.00331Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00255 6.00314C9.00255 4.36221 7.67239 3.03207 6.03145 3.03207C4.39052 3.03207 3.06038 4.36221 3.06038 6.00314C3.06038 7.64407 4.39052 8.97423 6.03145 8.97423C7.67239 8.97423 9.00255 7.64407 9.00255 6.00314ZM9.49263 6.00314C9.49263 7.91467 7.94299 9.46431 6.03146 9.46431C4.11995 9.46431 2.57031 7.91467 2.57031 6.00314C2.57031 4.09163 4.11996 2.54199 6.03146 2.54199C7.94299 2.54199 9.49263 4.09163 9.49263 6.00314Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5062 6.003C10.5062 3.53322 8.50405 1.53109 6.03425 1.53109C3.56445 1.53109 1.56234 3.53322 1.56234 6.003C1.56234 8.4728 3.56445 10.4749 6.03425 10.4749C8.50405 10.4749 10.5062 8.4728 10.5062 6.003ZM10.9963 6.003C10.9963 8.7434 8.77466 10.965 6.03425 10.965C3.29387 10.965 1.07227 8.74341 1.07227 6.003C1.07227 3.26262 3.29387 1.04102 6.03425 1.04102C8.77465 1.04102 10.9963 3.26262 10.9963 6.003Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85441 5.75781C6.71911 5.75781 6.60938 5.86758 6.60938 6.00285C6.60938 6.13815 6.71911 6.24792 6.85441 6.24792H11.7552C11.8905 6.24792 12.0002 6.13815 12.0002 6.00285C12.0002 5.86758 11.8905 5.75781 11.7552 5.75781H6.85441Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.245039 5.75781C0.109765 5.75781 0 5.86758 0 6.00285C0 6.13815 0.109765 6.24792 0.245039 6.24792H5.14567C5.28097 6.24792 5.39071 6.13815 5.39071 6.00285C5.39071 5.86758 5.28097 5.75781 5.14567 5.75781H0.245039Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24987 6.86125C6.24987 6.72595 6.14011 6.61621 6.0048 6.61621C5.86953 6.61621 5.75977 6.72595 5.75977 6.86125V11.7619C5.75977 11.8972 5.86953 12.007 6.0048 12.007C6.14011 12.007 6.24987 11.8972 6.24987 11.7619V6.86125Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24987 0.245039C6.24987 0.109737 6.14011 0 6.0048 0C5.86953 0 5.75977 0.109737 5.75977 0.245039V5.14565C5.75977 5.28095 5.86953 5.39069 6.0048 5.39069C6.14011 5.39069 6.24987 5.28095 6.24987 5.14565V0.245039Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewerIcon);
export default __webpack_public_path__ + "static/media/viewerIcon.a2504ae12561a08b7540abdc2d71c3d3.svg";
export { ForwardRef as ReactComponent };